export default {
  questions: [
    {
      questionId: 1,
      questionText:
        "คุณต้องการเพื่อนแบบไหนมากกว่ากันระหว่าง...",
      choices: [
        { choiceId: "A", text: "คนที่ดูเป็นมิตร สดใส ร่าเริง เข้ากับคนได้ไม่ยาก" },
        { choiceId: "B", text: "คนที่มองตาก็รู้ใจและเข้าใจคุณว่าบางครั้งชั้นก็อยากอยู่คนเดียวบ้าง" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 2,
      questionText: "เมื่อเพื่อนของคุณชวนให้คุณไปงานสังสรรค์ คุณชอบเพื่อนที่...",
      choices: [
        { choiceId: "A", text: "เฮฮาพาไปแล้วขำ ๆ คุยกับใครก็ได้ ชอบเจ๊าะแจ๊ะคนนั้นคนนี้" },
        { choiceId: "B", text: "ไม่กดดันให้ฉันต้องไปคุยกับคนนั้นคนนี้" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 3,
      questionText: "เมื่ออยู่ในกลุ่มของเพื่อน คุณชอบที่จะ...",
      choices: [
        { choiceId: "A", text: "เป็นจุดสนใจและเป็นจุดเด่นภายในกลุ่ม" },
        { choiceId: "B", text: "เป็นคน ๆ หนึ่งที่คอยรับฟังและสังเกตความเป็นไปของเพื่อนรอบข้าง" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 4,
      questionText: "เมื่ออยู่ในงานสังสรรค์ คุณมักจะอยู่ส่วนไหนของงาน?",
      choices: [
        { choiceId: "A", text: "อยู่หน้าเวที หรือส่วนที่มีคนอยู่เป็นกลุ่มเยอะ ๆ" },
        { choiceId: "B", text: "อยู่ตรงมุมสงบของงาน ที่ ๆ ไม่ค่อยมีคนพลุกพล่านและเสียงไม่ดังมาก" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 5,
      questionText: "เมื่อคุณต้องอยู่บ้านคนเดียวเวลานาน ๆ หลายวันมันทำให้คุณ...",
      choices: [
        { choiceId: "A", text: "รู้สึกเหนื่อยและคิดว่าฉันคงต้องออกไปเดินเล่นข้างนอก" },
        { choiceId: "B", text: "เหมือนกับได้เติมพลัง ได้อยู่คนเดียว ทำกิจกรรมที่อยากทำคนเดียว" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 6,
      questionText: "เมื่อคุณต้องอยู่กับกลุ่มคนเป็นจำนวนมากคุณรู้สึกว่า...",
      choices: [
        { choiceId: "A", text: "การที่มีเสียงจอแจบ้างทำให้บรรยากาศดูครึกครื้นดี" },
        { choiceId: "B", text: "รำคาญ อยากจะให้อยู่ในความสงบ เงียบ ๆ มากกว่า" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 7,
      questionText: "โดยปกติคุณคิดว่า ตัวเป็นคนที่...",
      choices: [
        { choiceId: "A", text: "พูดมากกว่าฟัง" },
        { choiceId: "B", text: "ฟังมากกว่าพูด" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 8,
      questionText: "เมื่อเวลาที่คุณต้องทำงานที่ต้องใช้สมาธิมาก ๆ คุณพบว่าตัวเองเป็นคนที่...",
      choices: [
        { choiceId: "A", text: "เสียสมาธิได้ง่าย" },
        { choiceId: "B", text: "มีสมาธิในการทำงานดี" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 9,
      questionText: "โดยปกติคุณเป็นคนที่รู้จักเพื่อนใหม่อย่างไร?",
      choices: [
        { choiceId: "A", text: "มักจะเข้าไปแนะนำตัวเองและเริ่มบทสนทนากับผู้อื่น" },
        { choiceId: "B", text: "มักรู้จักคนอื่นจากการแนะนำของเพื่อนที่รู้จักอีกที" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 10,
      questionText: "เวลาที่คุณรู้สึกเหนื่อย คุณจะเติมพลังด้วยการ...",
      choices: [
        { choiceId: "A", text: "สังสรรค์ หากิจกรรมคลายเครียดนอกบ้าน" },
        { choiceId: "B", text: "หยุดพักโดยลำพัง" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 11,
      questionText: "เวลาที่คุยประชุมเรื่องโครงงานต่าง ๆ ที่ผ่านมาคุณมักจะรู้สึกรำคาญคนที่...",
      choices: [
        { choiceId: "A", text: "เสนอความคิดเห็นมากมายแต่ไม่สามารถจับต้องอะไรได้เลย" },
        { choiceId: "B", text: "ทำให้เสียเวลาคุยเรื่องรายละเอียดปลีกย่อยในการแบ่งหน้าที่รับผิดชอบอย่างถี่ยิบ" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 12,
      questionText: "เวลาที่ได้รับงานมาคุณจะมีการจัดการทำงานในหัวอย่างไร?",
      choices: [
        { choiceId: "A", text: "เป็นขั้นเป็นตอน ไล่จาก 1 ไป 2 ไป 3" },
        { choiceId: "B", text: "ไม่ต้องมีแบบแผนใด ๆ ทั้งสิ้น คิดอะไรได้ก็เชื่อมโยงต่อ ๆ กันไป" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 13,
      questionText: "คุณเชื่อถือคนที่...",
      choices: [
        { choiceId: "A", text: "สามารถทำในสิ่งที่พูดได้จริง" },
        { choiceId: "B", text: "มีความคิดสร้างสรรค์ กล้าฉีกตัวเองออกจากกรอบ" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 14,
      questionText: "คุณให้ความสำคัญอะไรมากกว่ากันระหว่าง...",
      choices: [
        { choiceId: "A", text: "ปัจจุบัน" },
        { choiceId: "B", text: "อนาคต" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 15,
      questionText: "เมื่อคุณต้องเรียนรู้สิ่งใหม่ ๆ คุณจะเรียนรู้ได้ดีเมื่อ...",
      choices: [
        { choiceId: "A", text: "ได้สังเกตว่าคนอื่นทำอย่างไร และนำมาปรับใช้เป็นแบบฉบับของตัวเอง" },
        { choiceId: "B", text: "ลองแนวคิดใหม่ที่ฉีกจากสิ่งที่มีมาก่อนอย่างสิ้นเชิง" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 16,
      questionText: "คุณชอบโครงการที่มีลักษณะใดมากกว่ากันระหว่าง...",
      choices: [
        { choiceId: "A", text: "โครงการที่มีหลักการแนวคิดเป็นระบบ มีขั้นตอนที่แน่นอน" },
        { choiceId: "B", text: "โครงการใหม่ ๆ ที่ไม่เคยมีใครทำ เป็นโครงการที่ไม่ธรรมดา และสร้างแรงบันดาลใจได้อย่างแท้จริง" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 17,
      questionText: "คุณคิดว่าหัวหน้าแบบไหนที่คุณจะให้ความนับถือมากกว่ากัน?",
      choices: [
        { choiceId: "A", text: "หัวหน้าที่มีประสบการณ์ทำงานจริงมาอย่างโชกโชน" },
        { choiceId: "B", text: "หัวหน้าที่สามารถคาดการณ์ถึงความเป็นไปได้ที่กำลังจะเกิดขึ้นในอนาคตได้อย่างแม่นยำ" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 18,
      questionText: "เวลาที่หัวหน้าสั่งงาน คุณจะรู้สึกหงุดหงิดเมื่อเจอหัวหน้าสั่งงานแบบใดมากกว่ากันระหว่าง...",
      choices: [
        { choiceId: "A", text: "สั่งแบบรวม ๆ ให้ข้อมูลกว้าง ๆ โดยไม่เจาะจงว่าต้องการอะไรกันแน่ ชอบท้าทายความคิดให้คิดเอาเองว่าต้องการอะไร" },
        { choiceId: "B", text: "สั่งแบบบอกข้อกำหนดในการทำโครงการมาอย่างถี่ยิบ และตรวจเช็คความถูกต้องในทุกรายละเอียด" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 19,
      questionText: "คุณคิดว่าอะไรเป็นปัจจัยสำคัญในการจะประสบความสำเร็จในชีวิต?",
      choices: [
        { choiceId: "A", text: "การทำสิ่งที่ถูกต้อง สมเหตุสมผล" },
        { choiceId: "B", text: "การเป็นคนมีความคิดสร้างสรรค์" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 20,
      questionText: "เมื่อถึงเวลาที่ต้องตัดสินใจว่าจะทำอะไร คุณเชื่ออะไรมากกว่ากันระหว่าง...",
      choices: [
        { choiceId: "A", text: "ประสบการณ์ในอดีตและข้อมูลที่สนับสนุน" },
        { choiceId: "B", text: "สัญชาตญาณ ลางสังหรณ์" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 21,
      questionText: "เวลาที่คุณอยู่กับกลุ่มเพื่อนที่ทำงาน คุณจะหงุดหงิดเมื่อพวกเขาคุยกันเรื่องอะไร?",
      choices: [
        { choiceId: "A", text: "เรื่องส่วนตัวเกี่ยวกับความสัมพันธ์ของคนรอบตัวของพวกเขา ซึ่งนับเป็นเรื่องไร้สาระและเป็นเรื่องส่วนตัวที่ไม่ควรเอามาป่าวประกาศให้ทุกคนรู้" },
        { choiceId: "B", text: "เอาแต่คุยเรื่องงานและความคืบหน้าของหน้าที่ความรับผิดชอบที่เขาต้องรับผิดชอบ" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 22,
      questionText: "ถ้าคุณเป็นหัวหน้าที่ต้องคอยแบ่งงาน คุณจะแบ่งงานอย่างไร?",
      choices: [
        { choiceId: "A", text: "แบ่งหน้าที่ตามความรับผิดชอบ และหัวข้อที่แต่ละคนต้องรับไปทำ" },
        { choiceId: "B", text: "แบ่งตามความพร้อมและความสามารถของแต่ละคนว่าใครชอบที่จะทำหัวข้อไหนบ้าง" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 23,
      questionText: "คุณคิดว่าคุณเป็นคนที่...",
      choices: [
        { choiceId: "A", text: "ใจแข็ง" },
        { choiceId: "B", text: "ใจอ่อน" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 24,
      questionText: "เมื่ออยู่ในสถานการณ์ที่เพื่อนสองคนทะเลาะกัน คุณคิดว่ามันจะดีกว่าถ้าทั้งสองคน...",
      choices: [
        { choiceId: "A", text: "คุยกันให้เคลียร์ไปเลยว่าเกิดอะไรขึ้น และนับจากนี้จะทำอย่างไรต่อไป" },
        { choiceId: "B", text: "ประนีประนอมค่อย ๆ พูด ค่อย ๆ จากัน ปรับความเข้าใจกันดี ๆ จะดีกว่า" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 25,
      questionText: "เมื่อคุณรู้ว่าเพื่อนของคุณทำผิดกฎและถูกจับได้ จึงถูกทำโทษ ลึก ๆ แล้วคุณคิดว่า...",
      choices: [
        { choiceId: "A", text: "ก็เธอผิด เธอก็ควรที่จะรับผิดชอบในสิ่งที่เธอทำไปอยู่แล้ว" },
        { choiceId: "B", text: "สงสาร เห็นใจ เราน่าจะฟังเหตุผลส่วนตัวของเขาก่อนนะ เขาไม่น่าได้รับโทษที่รุนแรงขนาดนี้เลย" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 26,
      questionText: "สำหรับคุณแล้ว คำว่าความยุติธรรมหมายถึงอะไรระหว่าง...",
      choices: [
        { choiceId: "A", text: "ทุกคนต้องเท่ากัน ถ้าทำอย่างเดียวกันก็ควรได้รับผลเท่ากัน" },
        { choiceId: "B", text: "ทุกคนไม่เท่ากัน ความพยายามไม่เท่ากัน ความใส่ใจตั้งใจไม่เท่ากัน ต่อให้ผลออกมาเท่ากัน รางวัลก็ไม่ควรเท่ากัน" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 27,
      questionText: "เมื่อคุณต้องตัดสินใจเรื่องอะไรสักอย่าง คุณจะเชื่อ...",
      choices: [
        { choiceId: "A", text: "ข้อมูลเหตุผลในการตัดสินใจ" },
        { choiceId: "B", text: "ความรู้สึก อารมณ์ และความสัมพันธ์ในการตัดสินใจ" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 28,
      questionText: "เมื่ออยู่ในสถานการณ์ที่คุณต้องพูดอะไรบางอย่างออกไป คุณจะพูดสิ่งที่...",
      choices: [
        { choiceId: "A", text: "เป็นความจริง เป็นความถูกต้อง มากกว่าจะพูดในสิ่งที่เหมาะสม" },
        { choiceId: "B", text: "พูดในสิ่งที่เหมาะสม มากกว่าที่จะพูดในสิ่งที่เป็นความจริง" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 29,
      questionText: "ในการอยู่ร่วมกันในสังคม คุณคิดว่าสิ่งที่สำคัญคือการที่เราแต่ละคนต้อง...",
      choices: [
        { choiceId: "A", text: "ทำสิ่งที่ถูกต้อง สมเหตุสมผล" },
        { choiceId: "B", text: "เป็นคนมีความคิดสร้างสรรค์" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 30,
      questionText: "เวลาที่คุณรู้ว่าเพื่อนมีปัญหา คุณมักจะ...",
      choices: [
        { choiceId: "A", text: "วิเคราะห์ว่าเกิดอะไรขึ้น และทำการเสนอแนวทางที่ถูกต้องให้" },
        { choiceId: "B", text: "ก้าวเข้าไปอยู่กับสถานการณ์นั้นด้วย ชนิดที่ว่าเพื่อนเจ็บเราก็เจ็บ" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 31,
      questionText: "คุณคิดว่าอะไรเป็นสำคัญในการดำเนินชีวิตมากกว่ากันระหว่าง...",
      choices: [
        { choiceId: "A", text: "การใช้ชีวิตอย่างมีเป้าหมาย รู้ว่าเรากำลังทำอะไร และกำลังจะไปที่ไหน" },
        { choiceId: "B", text: "การใช้ชีวิตโดยรู้จักปรับตัวเข้ากับสถานการณ์รอบตัวให้ได้" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 32,
      questionText: "ในการทำโปรเจ็กต์ต่าง ๆ คุณมักจะเริ่มต้นทำเมื่อใด?",
      choices: [
        { choiceId: "A", text: "เริ่มต้นทำเลย และค่อย ๆ ทยอยทำไปเรื่อย ๆ" },
        { choiceId: "B", text: "เก็บข้อมูลก่อนว่าอะไรดีไม่ดี เอาไว้ใกล้ ๆ ถึงเวลาก่อนแล้วค่อยทำ" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 33,
      questionText: "คุณคิดว่าคุณเป็นคนที่...",
      choices: [
        { choiceId: "A", text: "ใจแข็ง" },
        { choiceId: "B", text: "ใจอ่อน" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 34,
      questionText: "คุณมักจะทำงานเสร็จพร้อมส่งหัวหน้าได้เมื่อใด",
      choices: [
        { choiceId: "A", text: "เสร็จก่อนเวลาสักพัก เพื่อให้คนอื่นลองอ่านและให้คำแนะนำก่อนส่ง" },
        { choiceId: "B", text: "เสร็จทันเวลาเป๊ะ ทำเสร็จแบบสด ๆ ร้อน ๆ" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 35,
      questionText: "ลักษณะการทำงานของคุณเป็นอย่างไร ระหว่าง...",
      choices: [
        { choiceId: "A", text: "มีความขยันที่คงเส้นคงวา ทยอยทำไปเรื่อย ๆ ไม่ชอบภาระในช่วงท้าย" },
        { choiceId: "B", text: "ทุ่มเทเป็นช่วง ๆ เวลาไหนส่งค่อยมาไล่ทำทีเดียวทั้งหมด" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 36,
      questionText: "ถ้าคุณได้เริ่มทำอะไรไปแล้วครึ่งหนึ่ง และต้องล้มเลิกกลางคัน คุณจะรู้สึกว่า...",
      choices: [
        { choiceId: "A", text: "โกรธ หงุดหงิดที่ทำให้แผนในการทำงานที่ผ่านมาต้องล้มเลิกไปหมด" },
        { choiceId: "B", text: "รู้สึกแย่บ้างแต่ก็ไม่เป็นไร เรื่องนี้ไม่ต้องทำแล้วก็เรื่องใหม่ทำก็สิ้นเรื่อง" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 37,
      questionText: "ถ้าเพื่อนจะชวนคุณไปเที่ยวต่างจังหวัดด้วยกัน คุณหวังว่าเขาจะบอกคุณล่วงหน้านานสักขนาดไหน?",
      choices: [
        { choiceId: "A", text: "บอกก่อนสักอาทิตย์นึงก็ดีนะจะได้เตรียมตัวถูกว่าไปได้หรือเปล่า" },
        { choiceId: "B", text: "บอกมาเลย ถ้าพรุ่งนี้ว่างก็ไปเลยก็ได้นะไม่ต้องเตรียมตัวอะไรมากมาย ก็เราไปเที่ยวกันนี่นา" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 38,
      questionText: "เวลาหัวหน้าขอให้คุณส่งหัวข้อโปรเจ็กต์ที่คุณอยากจะทำ ในตอนนี้คุณจะ...",
      choices: [
        { choiceId: "A", text: "รู้สึกดีขึ้นเมื่อหาหัวข้อได้แล้วและสรุปกับหัวหน้าไปเลยว่าจะทำเรื่องอะไร" },
        { choiceId: "B", text: "รู้สึกดีกว่าถ้าหัวหน้าจะไม่มากดดันเอาเวลานี้ ขอดูข้อมูลทั้งหลายก่อน" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 39,
      questionText: "ในการทำงานเป็นทีม คุณค้นพบว่าตัวเองเป็นคนที่...",
      choices: [
        { choiceId: "A", text: "เก่งเรื่องการปิดงาน และสรุปงานให้เสร็จก่อนเวลา" },
        { choiceId: "B", text: "เก่งเรื่องการเปิดประเด็น เริ่มต้นทำสิ่งต่าง ๆ" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 40,
      questionText: "มักจะมีคนบอกว่าคุณเป็นคนที่มีพรสวรรค์ในการ...",
      choices: [
        { choiceId: "A", text: "จัดการ วางแผน" },
        { choiceId: "B", text: "ปรับตัวเข้ากับสถานการณ์" }
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    }
  ]
};
